import { socialGroupsSlice } from '@app/store/slices/social-groups/social-groups';
export const { setGroupsList, setMembersList, setInviteCode } = socialGroupsSlice.actions;
export const { reducer: socialGroupsReducer } = socialGroupsSlice;
export * from './selectors';
